// Матчинг всех роутов зафиксирован таблицей «URL → паттерн + params»
// в src/tests/router/routeMatching.test.ts — при изменении путей обнови её
export const ROUTE_PAGE_HOME = '/'
export const ROUTE_PAGE_ACCOUNT = '/account'
export const ROUTE_PAGE_API = '/api'
export const ROUTE_PAGE_SUBSCRIPTION = '/subscription'
export const ROUTE_PAGE_SUBSCRIPTION_CHECKOUT = '/subscription/checkout'

export const ROUTE_PAGE_DASHBOARD = '/dashboard/:workspaceId?/:folderId?'
export const ROUTE_PAGE_DASHBOARD_ACTIVITY = '/dashboard/activity/:workspaceId'
export const ROUTE_PAGE_DASHBOARD_MEMBERS = '/dashboard/members/:workspaceId'
export const ROUTE_PAGE_DASHBOARD_SETTINGS = '/dashboard/settings/:workspaceId'
// Более специфичен, чем ROUTE_PAGE_DASHBOARD ('/dashboard/:workspaceId?/:folderId?'):
// статический сегмент ранжируется выше динамического, поэтому папку с id
// 'templates' этот путь не перехватывает — папки нумерованные
export const ROUTE_PAGE_DASHBOARD_TEMPLATES =
  '/dashboard/:workspaceId/templates'

export const DASHBOARD_ACTIVITY_LINK = '/dashboard/activity'
export const DASHBOARD_MEMBERS_LINK = '/dashboard/members'
export const DASHBOARD_SETTINGS_LINK = '/dashboard/settings'
export const DASHBOARD_LINK = '/dashboard'

export const PREVIEW_LINK = '/preview/:projectId'

// Пути старого дашборда: сами страницы удалены в OCT-4929, роуты временно
// оставлены редиректами на /dashboard, чтобы не ломать живые ссылки
export const LEGACY_PROJECTS = '/projects'
export const LEGACY_CREATE_TEAM = '/create-team'
export const LEGACY_TEAM = '/team/:teamId'
export const LEGACY_TEAM_FOLDER = '/team/:teamId/folder/:folderId'

// todo: fix naming
export const ROUTE_OAUTH = '/oauth'
export const ROUTE_JOIN_SLACK_PATH = '/join-slack'
export const ROUTE_PROMO_CRAWLER = '/promo-crawler'
export const ROUTE_PROMO_REPORT = '/promo-report'
export const ROUTE_TEMPLATES = '/templates'
export const ROUTE_IMPORT = '/import'
export const ROUTE_PRICING = '/pricing'
export const ROUTE_AI_SITEMAP = '/ai-sitemap'
export const ROUTE_EMBED = '/embed/:uuid'
export const ROUTE_FIGMA = '/oauth/callback/figma'
export const ROUTE_EXPORT_NODE = '/export/:projectId/page/:nodeId'
export const ROUTE_PASSWORD_RESET = '/password-reset/:uuid'
export const ROUTE_SIGNUP = '/signup'

// todo: иметь общий роут для /ai-sitemap/new-project&generationTheme=уцйукйцукй и /?ai-sitemap=1&new-project=1&generationTheme=уцйукйцукй
export const ROUTE_AI_SITEMAP_NEW = '/ai-sitemap/new-project'

export const SITEMAP_REPORT = '/sitemap-report/:uuid'

export const MAIN_ROUTES = [
  '/:uuid/:tabId/:entityType/:entityId/:modalType',
  '/:uuid/:entityType/:entityId/:modalType/',
  '/:uuid/:entityType/:modalType',
  '/:uuid',
]
